import apiClient from "../_helpers/api-client";

export const tipService = {
  getAll,
  getSection,
  setSection,
  pushItem,
  patchItem,
  putItem,
  deleteItem,
  getAvailableStatusChange,
  getOwners,
  createOwner,
  getCurrentOwnersItems,
  getPendingFadderItems,
  cancelMoveAEDs,
  createOrupdate,
  resendConfirmationEmail,
  changeWorkflowState
};

async function getAll({ id, parameters }) {
  return apiClient.get(`/api/v4/tipos/${id}`, { params: parameters });
}

async function getSection({ id, section, parameters }) {
  const data = await apiClient.get(`/api/v4/tipos/${id}/${section}`, {
    params: parameters
  });

  return { ...data, ...{ section } };
}

async function changeWorkflowState({ id, workflowState }) {
  return apiClient.patch(
    `/api/v4/tipos/${id}/workflowstate?state=${workflowState}`
  );
}

async function setSection({ method, data, id, section }) {
  return apiClient({
    url: `/api/v4/tipos/${id}/${section}`,
    method,
    data
  });
}

async function pushItem({ data, id, section, itemId }) {
  return apiClient.post(`/api/v4/tipos/${id}/${section}/${itemId || ""}`, data);
}

async function patchItem({ data, id, section, itemId }) {
  return apiClient.patch(
    `/api/v4/tipos/${id}/${section}/${itemId || ""}`,
    data
  );
}

async function putItem({ data, id, section, itemId }) {
  return apiClient.put(`/api/v4/tipos/${id}/${section}/${itemId || ""}`, data);
}

async function deleteItem({ data, id, section, itemId }) {
  return apiClient.delete(
    `/api/v4/tipos/${id}/${section}/${itemId || ""}`,
    data
  );
}
async function getOwners({ email }) {
  return apiClient.get(`/api/v4/profiles`, {
    params: {
      email
    }
  });
}
async function createOwner(data) {
  return apiClient.post(`/api/v4/tipos/fadder/`, data);
}
async function getCurrentOwnersItems({ profileId }) {
  return apiClient.get(`/api/v4/profiles/${profileId}/tipos`);
}
async function getPendingFadderItems({ profileId }) {
  return apiClient.get(`api/v4/profiles/${profileId}/pendingaeds`);
}
async function resendConfirmationEmail({ profileId }) {
  return apiClient.post(`api/v4/profiles/${profileId}/resendconfirmation`);
}
async function cancelMoveAEDs({ profileId, data }) {
  return apiClient.post(`api/v4/profiles/${profileId}/cancelmoveaeds`, data);
}
async function createOrupdate({ newOwner, data }) {
  return apiClient.post(
    `/api/v4/profiles/${
      newOwner ? "?incomplete=true" : data.profile + "/moveaeds"
    }`,
    data
  );
}
async function getAvailableStatusChange({ status }) {
  return apiClient.get(`/api/v4/status/${status}/`);
}
